module.exports = __webpack_public_path__ + "static/aitana-mas-69de25f8b4755acf0f7a94e35398b29e.jpg";